exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".upgrade-source__description{margin-bottom:16px}.upgrade-source__internal,.upgrade-source__type-description{margin:16px 0}.upgrade-source__wrong-settings-detected{margin-bottom:16px;line-height:20px}.upgrade-source__section-title{font-weight:700;margin-bottom:8px}.upgrade-source__section-title_spaced{margin-top:16px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/src?{}!./node_modules/sass-loader/lib/loader.js?sourcemap&outputStyle=expanded!./src/pages/upgrade-source/upgrade-source.scss
// module id = 811
// module chunks = 0